(function (angular, app) {
    'use strict';

    app.controller('CheckoutDidYouMeanCtrl', [
        '$scope', 'addresses',
        function ($scope, addresses) {
            var didYouMeanCtrl = this;
            didYouMeanCtrl.data = {};
            didYouMeanCtrl.addresses = addresses;

            didYouMeanCtrl.ok = function () {
                $scope.$dialog.hide({
                    address: didYouMeanCtrl.address,
                });
            };

            didYouMeanCtrl.cancel = function () {
                $scope.$dialog.hide();
            };
        }]);
})(angular, app);
